import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface PlanLimitAlert {
  title: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class AlertService {
  private _planLimit$ = new BehaviorSubject<PlanLimitAlert | null>(null);

  //Observable que emite cuando se debe mostrar el modal de límite de plan 
  readonly planLimit$ = this._planLimit$.asObservable();

  showPlanLimit(alert: PlanLimitAlert): void {
    this._planLimit$.next(alert);
  }

  clearPlanLimit(): void {
    this._planLimit$.next(null);
  }
}
